import { setLocale } from 'yup';
import { phoneNumber,isNullOrUndefined } from '@shared/utils';

setLocale({
	string: {
		length: ({ length }) => ({ value: 'mobileLength', action: 't', params: { field: { value: length } } }),
	},
});

function mobile() {
	return this
		.length(11)
		.test({
			name: 'checkMobile',
			exclusive: true,
			message: {
				value: 'inValidMobile',
				action: 't',
			},
			test(value) {
				return isNullOrUndefined(value) || phoneNumber(value)
			},
		})
} // mobile()

function setup(yup) {
	yup.addMethod(yup.string, 'mobile', mobile)
}

export default setup;
